import type { CityConfig } from "../city-template/types";

export const fairfaxVaConfig: CityConfig = {
  city: "Fairfax",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "fairfax-va",
  route: "/cities/fairfax-va",
  title: "Emergency Passport Fairfax, VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fairfax, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Fairfax City, Fairfax County, Vienna, Oakton, Centreville, and all of Northern Virginia. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Fairfax, VA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Fairfax and Northern Virginia travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20Fairfax%20Virginia%20downtown%20cityscape%20at%20golden%20hour%20with%20historic%20Fairfax%20County%20courthouse%2C%20charming%20brick%20buildings%20along%20Main%20Street%2C%20mature%20maple%20trees%20lining%20the%20street%2C%20autumn%20foliage%20with%20warm%20orange%20and%20golden%20tones%2C%20soft%20evening%20light%2C%20professional%20photography%20with%20rich%20warm%20colors%20and%20clean%20architectural%20detail%2C%20no%20people%20visible%2C%20small-town%20America%20meets%20suburban%20elegance&width=1800&height=700&seq=fairfax-va-hero-001&orientation=landscape",
  heroImageAlt: "Historic Fairfax Virginia downtown with courthouse and charming Main Street at golden hour",
  geoPosition: "38.8462;-77.3064",
  geoPlacename: "Fairfax, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 18 miles from Fairfax via I-66",
  },
  nearbyCitiesZips: [
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22034, 22035, 22036, 22037, 22038, 22039" },
    { name: "Fairfax City", zips: "22030, 22031" },
    { name: "Vienna", zips: "22180–22182" },
    { name: "Oakton", zips: "22124" },
    { name: "Centreville", zips: "20120, 20121" },
    { name: "Chantilly", zips: "20151, 20152" },
    { name: "Burke", zips: "22015" },
    { name: "Springfield", zips: "22150–22153" },
    { name: "Annandale", zips: "22003" },
    { name: "Falls Church", zips: "22040–22046" },
    { name: "Merrifield", zips: "22116" },
    { name: "Dunn Loring", zips: "22027" },
    { name: "McLean", zips: "22101, 22102" },
    { name: "Tysons Corner", zips: "22102" },
    { name: "Reston", zips: "20190–20194" },
    { name: "Herndon", zips: "20170–20172" },
    { name: "Sterling", zips: "20164, 20165" },
    { name: "Ashburn", zips: "20147, 20148" },
    { name: "Leesburg", zips: "20175, 20176" },
    { name: "Manassas", zips: "20110, 20111" },
    { name: "Woodbridge", zips: "22191, 22192, 22193" },
    { name: "Arlington", zips: "22201–22217" },
    { name: "Alexandria", zips: "22301–22315" },
    { name: "Richmond", zips: "23218–23242" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Fairfax departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NoVA Hub", desc: "Serving Fairfax City, Fairfax County, and all of Northern Virginia" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Arlington VA passport services", route: "/cities/arlington-va" },
    { name: "Alexandria VA passport services", route: "/cities/alexandria-va" },
    { name: "McLean VA passport services", route: "/cities/mclean-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fairfax remotely via secure courier. We do not have a walk-in office in Fairfax — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Fairfax and Northern Virginia travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Fairfax and the surrounding Northern Virginia area including Fairfax City, Vienna, Oakton, Centreville, Chantilly, Burke, Springfield, Annandale, and all of Fairfax County",
  serviceAreaIntro: "From the historic downtown of Fairfax City to the bustling corridors of Fairfax County, from the quiet neighborhoods of Vienna and Oakton to the growing communities of Centreville and Chantilly — Fast Passport Center serves every corner of Fairfax and Northern Virginia. We regularly help travelers from Burke, Springfield, Annandale, Falls Church, and McLean get their passports fast.",
  nearbyCitiesIntro: "We serve all Fairfax neighborhoods and the surrounding Northern Virginia metro area including Fairfax City, Vienna, Oakton, Centreville, Chantilly, Burke, Springfield, Annandale, Falls Church, Merrifield, Dunn Loring, McLean, Tysons Corner, Reston, Herndon, Sterling, Ashburn, Leesburg, Manassas, Woodbridge, Arlington, and Alexandria. If you are anywhere in the Fairfax County or Northern Virginia region, we have you covered.",
  howItWorksIntro: "Most Fairfax travelers complete everything online and ship documents overnight. No need to drive into Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Fairfax travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Fairfax and Northern Virginia travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fairfax? Here are the most common ones we hear from Northern Virginia travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Fairfax international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Fairfax, VA",
      rating: 5,
      text: "My passport expired three weeks before my study abroad semester at Oxford. Fast Passport Center had my renewal processed in 4 days. I shipped from the Fairfax UPS on Main Street and never had to leave the county. Incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "David R.",
      location: "Centreville, VA",
      rating: 5,
      text: "Emergency passport for a government contractor assignment in Germany. I was facing a deadline that could have cost me the contract. Fast Passport Center delivered in 36 hours. Their Fairfax team knew exactly what I needed.",
      service: "Emergency Passport",
    },
    {
      name: "Maria S.",
      location: "Vienna, VA",
      rating: 5,
      text: "First passports for my twin daughters before our family trip to Costa Rica. Fast Passport Center handled the parental consent requirements perfectly and had both passports in 5 days. The Fairfax-area service was outstanding.",
      service: "Child Passport",
    },
    {
      name: "Robert K.",
      location: "Oakton, VA",
      rating: 5,
      text: "Lost my passport 72 hours before a flight to Tokyo for a tech conference. I was absolutely panicking. Fast Passport Center had a replacement in my hands in 28 hours. They saved a major client presentation.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "fairfax-va-1",
      name: "Fairfax Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4000 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 359-4276",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Fairfax, near Fairfax County Government Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Fairfax facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "fairfax-va-2",
      name: "Vienna Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Lawyers Rd NW",
      city: "Vienna",
      state: "VA",
      zip: "22180",
      phone: "(703) 938-3551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Vienna, near the town center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Vienna and east Fairfax area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "fairfax-va-3",
      name: "Fairfax County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "4110 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fairfax County Government Center",
      website: "https://www.fairfaxcounty.gov/",
      websiteLabel: "Fairfax County Clerk",
      notes: "Major county facility for Fairfax County. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "fairfax-va-4",
      name: "Centreville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15405 Lee Hwy",
      city: "Centreville",
      state: "VA",
      zip: "20120",
      phone: "(703) 830-3214",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Centreville, west of Fairfax City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Centreville and western Fairfax County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "fairfax-va-5",
      name: "Springfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7201 Old Keene Mill Rd",
      city: "Springfield",
      state: "VA",
      zip: "22150",
      phone: "(703) 455-7626",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Springfield, south of Fairfax",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Springfield and south Fairfax area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "fairfax-va-6",
      name: "Chantilly Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14004 Thunderbolt Pl",
      city: "Chantilly",
      state: "VA",
      zip: "20151",
      phone: "(703) 378-1145",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chantilly, near Dulles Airport",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chantilly and northwest Fairfax County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Fairfax photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Northern Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Fairfax applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Fairfax families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Fairfax travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fairfax or Vienna." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fairfax address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fairfax before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Fairfax for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the drive into downtown Washington, DC." },
    { q: "How fast can I renew my passport in Fairfax?", a: "Fast Passport Center offers fast passport renewal in Fairfax in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Fairfax?", a: "The nearest regional passport agency to Fairfax is the Washington Passport Agency, located approximately 18 miles away in downtown Washington, DC. For urgent processing without navigating DC traffic and parking, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Fairfax without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Fairfax?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Fairfax residents." },
    { q: "Can I expedite a child passport in Fairfax?", a: "Yes. Fast Passport Center expedites child passports in Fairfax for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Fairfax families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fairfax with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Fairfax?", a: "With Fast Passport Center's emergency courier service, Fairfax travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Fairfax?", a: "Popular options include the Fairfax Main Post Office (22030), Vienna Post Office (22180), Fairfax County Clerk (22030), Centreville Post Office (20120), Springfield Post Office (22150), and Chantilly Post Office (20151). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Fairfax?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the DC traffic and parking hassle." },
    { q: "What if I live in a smaller Fairfax County town?", a: "We serve the entire Fairfax County and Northern Virginia region including Vienna, Oakton, Centreville, Chantilly, Burke, Springfield, Annandale, Falls Church, Merrifield, McLean, Tysons, Reston, Herndon, Sterling, Ashburn, Leesburg, and Manassas. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Fairfax?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Fairfax?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx Office locations in Fairfax, Vienna, and Centreville offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Fairfax?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Fairfax?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Fairfax families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fairfax", address: "10560 Main St, Fairfax, VA 22030", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Fairfax", address: "13050 Lee Jackson Memorial Hwy, Fairfax, VA 22033", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Fairfax", address: "11260 James Swart Cir, Fairfax, VA 22030", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Vienna", address: "212 Maple Ave E, Vienna, VA 22180", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Centreville", address: "14125 Saint Germain Dr, Centreville, VA 20121", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Chantilly", address: "14101 Sullyfield Cir, Chantilly, VA 20151", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Springfield", address: "6400 Springfield Plaza, Springfield, VA 22150", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Burke", address: "9540 Old Keene Mill Rd, Burke, VA 22015", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Fairfax",
      address: "4110 Chain Bridge Rd, Fairfax, VA 22030",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Centreville",
      address: "6201 Multiplex Dr, Centreville, VA 20121",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Springfield",
      address: "7764 Gunston Plaza, Springfield, VA 22153",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Springfield and south Fairfax residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Tysons",
      address: "1960 Chain Bridge Rd, Tysons, VA 22102",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves eastern Fairfax County and Tysons area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "15 miles west of Fairfax",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The primary international airport for Fairfax and Northern Virginia. Major hub for long-haul flights to Europe, Asia, and the Caribbean. Accessible via Route 28 and Dulles Toll Road.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "16 miles southeast of Fairfax",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Alternative major airport for domestic flights and international connections. Accessible via I-66 and GW Parkway.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "55 miles northeast of Fairfax",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for international flights. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};